// shared/inputs/EnumSelectEditCell.tsx

import React from "react";
import { GridRenderEditCellParams } from "@mui/x-data-grid";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";

interface EnumSelectEditCellProps extends GridRenderEditCellParams {
  enumObject: readonly string[];
  formatFn?: (value: any) => string;
}

export const EnumSelectEditCell: React.FC<EnumSelectEditCellProps> = ({
  id,
  field,
  value,
  enumObject,
  api,
  formatFn = (v) => v,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    api.setEditCellValue({ id, field, value: event.target.value });
  };

  return (
    <Select
      value={value ?? ""}
      onChange={handleChange}
       onClick={(e) => e.stopPropagation()} // ✅ מונע מעבר ל־RowClick
      fullWidth
      size="small"
    >
      {enumObject.map((val) => (
        <MenuItem key={val} value={val}>
          {formatFn(val)}
        </MenuItem>
      ))}
    </Select>
  );
};
